import { render, staticRenderFns } from "./ServicePaymentDetailHeader.vue?vue&type=template&id=850928ea&scoped=true&"
import script from "./ServicePaymentDetailHeader.vue?vue&type=script&lang=js&"
export * from "./ServicePaymentDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./ServicePaymentDetailHeader.vue?vue&type=style&index=0&id=850928ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850928ea",
  null
  
)

export default component.exports